import { useEffect, useState } from 'react'
import dayjs from 'dayjs'
import {
  DislikeOutlined,
  EyeInvisibleOutlined,
  SendOutlined,
  ClockCircleOutlined,
  CheckSquareOutlined,
} from '@ant-design/icons'

import { StatusTicketEnum } from '@types'

interface CardIndicatorProps {
  dateCreated: Date
  status: string
  date: string | undefined
  withdrawalDate: Date
}

const CardIndicator = ({ dateCreated, status, date, withdrawalDate }: CardIndicatorProps) => {
  const [statusColor, setStatusColor] = useState('green')
  const { TRANSIT, CANCELED, NO_SHOW, PENDING, DELIVERED } = StatusTicketEnum

  const checkForUpdates = () => {
    setInterval(handleSetStatusColor, 1000 * 6)
  }
  const handleSetStatusColor = () => {
    if (date) {
      const timePassed = dayjs().diff(dayjs(date))
      if (timePassed < 3600000) {
        setStatusColor('green')
      } else if (timePassed < 7200000) {
        setStatusColor('yellow')
      } else {
        setStatusColor('red')
      }
    }
  }
  useEffect(() => {
    if (status === PENDING) {
      handleSetStatusColor()
      checkForUpdates()
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return (
    <>
      <div
        className={`${status} ${statusColor} ${dayjs(withdrawalDate) < dayjs() ? 'expired' : ''}`}
      />
      {dateCreated > withdrawalDate && <ClockCircleOutlined />}
      {status === TRANSIT && <SendOutlined />}
      {status === CANCELED && <DislikeOutlined />}
      {status === NO_SHOW && <EyeInvisibleOutlined />}
      {status === DELIVERED && <CheckSquareOutlined />}
    </>
  )
}

export default CardIndicator
